import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MvsObjectNavigationService} from 'features/core/shared/navigation/mvs-object-navigation.service';
import {CpRunAgentRef} from '../../../interface/cp-run-agent-ref.interface';
import {cpOpenProvisionAgent} from '../../../service/domain/cp-object-navigation';

/**
 * Read-only list of agents in the run review: name, Vermittler-Id and the Abrechnungskonto.
 *
 * The Vermittler-Id is shown on purpose next to the name: two agents may carry the SAME name
 * (the M-004 case of the review — "Gönül Güler" twice), and the id is the only fact that tells
 * them apart. An agent without an account is shown with an explicit "kein Abrechnungskonto" tag
 * instead of a link, because that absence IS the finding.
 *
 * The only action is NAVIGATION to the Abrechnungskonto (`cp.ProvisionAgent` object page) through
 * the standard object navigation — nothing here writes.
 */
@Component({
    selector: 'cp-run-detail-agent-list',
    templateUrl: './cp-run-detail-agent-list.component.html',
    styleUrls: ['./cp-run-detail-agent-list.component.scss'],
    standalone: false
})
export class CpRunDetailAgentListComponent implements OnInit, OnChanges {

    initialized: boolean;

    /** Agents to show; an empty list renders {@link emptyText}. */
    @Input() agents: CpRunAgentRef[] = [];

    /** German text for "no agent" — e.g. the M-002 situation "kein Hauptvermittler". */
    @Input() emptyText: string = 'Kein Vermittler zugeordnet.';

    constructor(protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /** Initialize component — pure display, nothing to load. */
    initComponent(): void {
        this.initialized = true;
    }

    /** Pure display: the template reads the inputs directly, nothing to recompute. */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
    }

    /** Open the Abrechnungskonto of an agent on its object page, read-only. */
    openAccount(agent: CpRunAgentRef): void {
        cpOpenProvisionAgent(this.navigationService, agent?.provisionAgentId);
    }
}
